
import { Component, SortColumn, SortDirection } from "@/utils/types/componentTypes";
import { Table, TableBody } from "@/components/ui/table";
import { ComponentsTableHeader } from "./ComponentsTableHeader";
import { ComponentsTableRow } from "./ComponentsTableRow";
import { ComponentsTableStatus } from "./ComponentsTableStatus";

interface ComponentsTableProps {
  components: Component[];
  loading: boolean;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
  onEdit: (component: Component) => void;
  onDelete: (component: Component) => void;
}

export function ComponentsTable({
  components,
  loading,
  sortColumn,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
}: ComponentsTableProps) {
  const isEmpty = components.length === 0;

  return (
    <div className="bg-card rounded-lg overflow-hidden border border-border/40">
      <Table>
        <ComponentsTableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableBody>
          <ComponentsTableStatus loading={loading} isEmpty={isEmpty} />
          
          {!loading && !isEmpty && components.map((component) => (
            <ComponentsTableRow 
              key={component.id}
              component={component} 
              onEdit={onEdit} 
              onDelete={onDelete}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
